export type Ingredient = { name: string; amount: string }

export function normalizeIngredients(raw: unknown): Ingredient[] {
  if (!Array.isArray(raw)) return []
  return raw
    .map((item) => {
      if (!item || typeof item !== 'object') return null
      const row = item as Record<string, unknown>
      const name = String(row.name ?? row.item ?? '').trim()
      const amount = String(row.amount ?? row.quantity ?? row.quantity_mass ?? '').trim()
      if (!name) return null
      return { name, amount: amount || 'as needed' }
    })
    .filter((x): x is Ingredient => x !== null)
}
